<template>
    <div class="suggestions-highlight-switcher">
        <Switcher v-model="value" />
        <div v-text="label" />
    </div>
</template>

<script>
import Switcher from '@speechki-frontend/shared/ui/Switcher';

const KEY = 'suggestions-highlight';

export default {
    name: 'SuggestionsHighlightSwitcher',
    components: {
        Switcher
    },
    props: {
        label: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            value: JSON.parse(localStorage.getItem(KEY))
        };
    },
    watch: {
        value(val) {
            localStorage.setItem(KEY, JSON.stringify(val));
            this.highlight();
        }
    },
    methods: {
        highlight() {
            document.querySelectorAll('.sentence[data-suggestions]').forEach(el => {
                if (this.value) el.classList.add('sentence--suggestion');
                else el.classList.remove('sentence--suggestion');
            });
        }
    }
};
</script>

<style lang="scss" src="./SuggestionsHighlightSwitcher.scss"></style>
